import cx from "classnames";
import type { Element } from "React";
import "./IconBrokerage.scss";
type Props = {
  className?: string;
  isPending?: boolean;
};

const IconBrokerage = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={cx(props.className, "icon__icon-brokerage", {
      "icon--pending": props.isPending,
    })}
  >
    <title id="title">Brokerage Mode</title>
    <g>
      <g transform="translate(7 6)">
        <ellipse cx="5" cy="3" rx="2.625" ry="2.5" />
        <path d="M.5 11.5h9v-1.1a4.5 4.5 0 0 0-9 0v1.1z" />
      </g>
      <path d="M7 11.5H3M4.5 13.621L2.379 11.5 4.5 9.379" />
      <g>
        <path d="M17 11.5h4M19.5 9.379l2.121 2.121-2.121 2.121" />
      </g>
    </g>
  </svg>
);

export default IconBrokerage;
